/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleDownLeftIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABNElEQVR4nO2UQUoEQQxFSxRmISMII3gAPYAHkF7oQGF3kkIok1aPogdRvIF3UEEEF7rQWcwJXCjoRvcOoatlWhGZniqYhR8CRTfk5VeSMuZfMyVwcoNOPpvBH0g8BOJTxL3tqQBIfP0TIM0gvsp3y/Vorvr9w0VE2UAnR0D8HFy9EfGmiS1E7ILjc4UAySuAX4sOMcbMfUGcXKYAGGsPlpDkRSEF8VYSCBAfh8afJAFg1XidqmEiAHZDs9+TAFT1bpgYstZ2sixbSAKw1nbA8ROS3BdF2fsNYL1f0dFFJ2cTAbz385o8bPGDJvoO0G9IMgj7cTGxizzfXwbHd/Xk7Hi/WgOqyvlx/J9po6Ioe+qgSlRV2ziTDGp3rZWPO2m+su0r/xMSM7kJ0usCx7caU1/LTGsEn265qfDHb1AAAAAASUVORK5CYII=)
 */
export const ArrowAngleDownLeftIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.7 21.7a1 1 0 0 1-1.4 0l-5-5a1 1 0 1 1 1.4-1.4l3.3 3.29V13a7 7 0 0 0-7-7H4a1 1 0 1 1 0-2h4a9 9 0 0 1 9 9v5.59l3.3-3.3a1 1 0 0 1 1.4 1.42l-5 5Z"
        className={colorClass}
      />
    </svg>
  );
};
